import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { PopupMenu, type PopupMenuEntry } from '@kerfjs/ui/popup-menu';
import { ToolbarControlGroup } from '@kerfjs/ui/toolbar-control-group';
import type { SafeHtml } from 'kerfjs';
import { ArrowUpDown } from 'lucide';

import { chatSortDirection, chatSortField } from '../../../data/state.js';

/** Compact sort menu used by the production chat sidebar: Kerf's PopupMenu with a
 *  checked item for the current field and direction (HS2-0ZYSMS). */
export function ChatSortMenu(): SafeHtml {
  const field = chatSortField.value;
  const direction = chatSortDirection.value;
  const choice = (label: string, action: string, id: string, checked: boolean): PopupMenuEntry => ({
    label,
    action,
    checked,
    attributes: { 'data-item-id': id },
  });
  return (
    <ToolbarControlGroup
      label="Chat Sorting"
      appearance="borderless"
      size="compact"
      density="tight"
      content="icon"
      single={true}
      nestedDropdown={true}
    >
      <PopupMenu
        label="Sort Chats"
        icon={<LucideIcon icon={ArrowUpDown} name="" />}
        caret={false}
        placement="bottom-end"
        rootAttributes={{ 'data-chat-sort-menu': '' }}
        items={[
          { kind: 'heading', label: 'Sort By' },
          choice('Updated', 'chat-sort-field', 'updated', field === 'updated'),
          choice('Created', 'chat-sort-field', 'created', field === 'created'),
          { kind: 'heading', label: 'Order' },
          choice('Newest first', 'chat-sort-direction', 'desc', direction === 'desc'),
          choice('Oldest first', 'chat-sort-direction', 'asc', direction === 'asc'),
        ]}
      />
    </ToolbarControlGroup>
  );
}
